<div class="card">
  <div class="card-body">
    <div class="card-title"><h3>Find an existing user to add as LE partner</h3></div>
    <div [formGroup]="findAPartnerForm" class="row gy-2 gx-3 align-items-center mb-3">
      <label for="searchPartnerNameInput" class="col-auto col-form-label">Search by name:</label>
      <div class="col-auto">
        <input id="searchPartnerNameInput" type="text" formControlName="SearchInput" class="form-control form-control-sm mb-2" />
      </div>
      <div class="col-auto">
        <button type="button" (click)="onSearchPerson()" class="btn btn-sm btn-success mb-2" label="Find"><i class="fas fa-search" aria-hidden="true"></i> Find</button>
      </div>
    </div>
    <p-messages key="findLEPartnerMsg" [closable]="true"></p-messages>
    <ng-container *ngIf="findLEPartnerResults$ | async as findLEPartnerResults">
      <p-table #dt [value]="findLEPartnerResults" [columns]="searchResultTableCols" selectionMode="single" [(selection)]="selectedPerson" (onRowSelect)="onSelectPartner($event)" [paginator]="true" [alwaysShowPaginator]="false" [rows]="rows" [autoLayout]="true" responsiveLayout="scroll">
        <ng-template pTemplate="caption">
          <div class="p-2 fw-medium text-center">Find existing user results</div>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" scope="col" [pSortableColumn]="col.field">
              {{col.header}}
              <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-partner>
          <tr [pSelectableRow]="partner">
            <td>{{partner.LastName}}</td>
            <td>{{partner.FirstName}}</td>
            <td>{{partner.ENESS_XREF_LEPartnersPhoneNumbers | displayPrimaryPhone }}</td>
            <td>{{ partner.ENESS_XREF_LEPartnersEmailAccounts.length > 0 ? partner.ENESS_XREF_LEPartnersEmailAccounts[0].EmailAccount : '' }}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">
              No user(s) found.
            </td>
          </tr>
        </ng-template>
      </p-table>
    </ng-container>
  </div>
</div>
